import React from 'react'

interface Props {
  components: React.JSXElementConstructor<React.PropsWithChildren<unknown>>[]
  children?: React.ReactNode
}

const Compose: React.FC<Props> = ({ components, children }: Props) => {
  return (
    <>
      {(components ?? []).reduceRight(
        (acc, Comp) => (
          <Comp>{acc}</Comp>
        ),
        children
      )}
    </>
  )
}

export default Compose
